"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../components/constants");
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
var _mergeProps = _interopRequireDefault(require("../../utils/mergeProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */ // eslint-disable-next-line import/no-unresolved
var getBorderColor = function getBorderColor(_ref) {
  var props = _ref.props,
    state = _ref.state,
    theme = _ref.theme;
  if (props.errorText) {
    return theme.colors.alert;
  }
  if (props.button === "flat") {
    return "transparent";
  }
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  return theme.colors.baseContrast060;
};
var getColor = function getColor(_ref2) {
  var props = _ref2.props,
    state = _ref2.state,
    theme = _ref2.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  if (state.isSelected && !props.hasCheckbox) {
    return (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, theme.colors.textOnDark, theme.colors.textOnLight, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD);
  }
  return theme.colors.baseContrast070;
};
var getPlaceholderStyles = function getPlaceholderStyles(_ref3) {
  var state = _ref3.state,
    theme = _ref3.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  return theme.mode === "light" ? theme.colors.baseContrast040 : theme.colors.baseContrast060;
};
var getSingleValueStyles = function getSingleValueStyles(_ref4) {
  var state = _ref4.state,
    theme = _ref4.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  return theme.colors.baseContrast090;
};
var mainSelectStyles = {
  clearIndicator: function clearIndicator(_ref5) {
    var props = _ref5.props,
      theme = _ref5.theme;
    return {
      "& svg": {
        fill: theme.colors.baseContrast040,
        "&:hover": {
          fill: props.errorText ? theme.colors.alert : theme.colors.primary
        }
      }
    };
  },
  control: function control(_ref6) {
    var state = _ref6.state,
      props = _ref6.props,
      theme = _ref6.theme;
    return {
      borderColor: getBorderColor({
        state: state,
        props: props,
        theme: theme
      }),
      borderWidth: props.errorText ? 2 : 1,
      borderRadius: 2,
      paddingInlineStart: theme.spacing.base - 1,
      boxShadow: "none",
      background: state.isFocused ? theme.colors.baseContrast020 : "none",
      "&:hover": {
        cursor: "pointer",
        background: theme.colors.baseContrast020
      }
    };
  },
  placeholder: function placeholder(_ref7) {
    var state = _ref7.state,
      theme = _ref7.theme;
    return {
      color: getPlaceholderStyles({
        state: state,
        theme: theme
      })
    };
  },
  dropdownIndicator: function dropdownIndicator(_ref8) {
    var state = _ref8.state,
      theme = _ref8.theme;
    return {
      width: theme.spacing.base * 4,
      marginInlineEnd: theme.spacing.base,
      "& svg": {
        fill: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseContrast060
      }
    };
  },
  indicatorSeparator: function indicatorSeparator(_ref9) {
    var state = _ref9.state,
      theme = _ref9.theme;
    return {
      margin: 0,
      position: "relative",
      top: "30%",
      height: "40%",
      width: 2,
      background: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseInvariant,
      borderRadius: 2
    };
  },
  multiValue: function multiValue(_ref10) {
    var state = _ref10.state,
      theme = _ref10.theme;
    return {
      borderRadius: 2,
      background: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseContrast060,
      "& > :first-of-type": {
        paddingInlineStart: theme.spacing.base
      }
    };
  },
  multiValueLabel: function multiValueLabel(_ref11) {
    var theme = _ref11.theme;
    return {
      color: theme.colors.baseContrast020
    };
  },
  multiValueRemove: function multiValueRemove(_ref12) {
    var props = _ref12.props,
      state = _ref12.state,
      theme = _ref12.theme;
    return {
      color: theme.colors.baseContrast020,
      background: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseContrast060,
      borderRadius: 2,
      "&:hover": {
        background: theme.colors.baseContrast060,
        color: props.errorText ? theme.colors.alert : theme.colors.primary
      }
    };
  },
  menu: function menu(_ref13) {
    var theme = _ref13.theme;
    return {
      borderRadius: 2,
      borderColor: theme.colors.baseInvariant,
      borderWidth: 1,
      borderStyle: "solid",
      backgroundColor: theme.colors.pageBackground,
      zIndex: 3
    };
  },
  option: function option(_ref14) {
    var state = _ref14.state,
      props = _ref14.props,
      theme = _ref14.theme;
    return {
      minHeight: theme.spacing.base * 4,
      height: "auto",
      paddingTop: theme.spacing.base * 0.75,
      paddingInlineStart: theme.spacing.base * 2,
      color: getColor({
        state: state,
        props: props,
        theme: theme
      }),
      background: props.hasCheckbox && state.isSelected ? "inherit" : null,
      cursor: state.isDisabled ? "default" : "pointer"
    };
  },
  singleValue: function singleValue(_ref15) {
    var state = _ref15.state,
      theme = _ref15.theme;
    return {
      color: getSingleValueStyles({
        state: state,
        theme: theme
      })
    };
  },
  valueContainer: function valueContainer() {
    return {
      padding: 0
    };
  }
};
var themeStyles = function themeStyles(theme) {
  var _theme$components;
  return theme !== null && theme !== void 0 && (_theme$components = theme.components) !== null && _theme$components !== void 0 && (_theme$components = _theme$components.Select) !== null && _theme$components !== void 0 && _theme$components.select ? theme.components.Select.select : {};
};
var getOverrides = function getOverrides(props, theme, overrides) {
  return function (name, state) {
    return overrides[name] ? typeof overrides[name] === "function" ? overrides[name]({
      state: state,
      props: props,
      theme: theme
    }) : overrides[name] : {};
  };
};
var createSelectOverrides = function createSelectOverrides(theme, props) {
  var _props$reactSelectOve;
  var mainOverrides = getOverrides(props, theme, mainSelectStyles);
  var themeOverrides = getOverrides(props, theme, themeStyles(theme));
  var propsOverrides = getOverrides(props, theme, (_props$reactSelectOve = props.reactSelectOverrides) !== null && _props$reactSelectOve !== void 0 ? _props$reactSelectOve : {});
  return {
    control: function control(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("control", state), themeOverrides("control", state))), propsOverrides("control", state));
    },
    placeholder: function placeholder(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("placeholder", state), themeOverrides("placeholder", state))), propsOverrides("placeholder", state));
    },
    dropdownIndicator: function dropdownIndicator(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("dropdownIndicator", state), themeOverrides("dropdownIndicator", state))), propsOverrides("dropdownIndicator", state));
    },
    indicatorSeparator: function indicatorSeparator(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("indicatorSeparator", state), themeOverrides("indicatorSeparator", state))), propsOverrides("indicatorSeparator", state));
    },
    multiValue: function multiValue(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("multiValue", state), themeOverrides("multiValue", state))), propsOverrides("multiValue", state));
    },
    multiValueLabel: function multiValueLabel(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("multiValueLabel", state), themeOverrides("multiValueLabel", state))), propsOverrides("multiValueLabel", state));
    },
    multiValueRemove: function multiValueRemove(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("multiValueRemove", state), themeOverrides("multiValueRemove", state))), propsOverrides("multiValueRemove", state));
    },
    menu: function menu(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("menu", state), themeOverrides("menu", state))), propsOverrides("menu", state));
    },
    option: function option(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("option", state), themeOverrides("option", state))), propsOverrides("option", state));
    },
    singleValue: function singleValue(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("singleValue", state), themeOverrides("singleValue", state))), propsOverrides("singleValue", state));
    },
    clearIndicator: function clearIndicator(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("clearIndicator", state), themeOverrides("clearIndicator", state))), propsOverrides("clearIndicator", state));
    },
    container: function container(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("container", state), themeOverrides("container", state))), propsOverrides("container", state));
    },
    group: function group(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("group", state), themeOverrides("group", state))), propsOverrides("group", state));
    },
    groupHeading: function groupHeading(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("groupHeading", state), themeOverrides("groupHeading", state))), propsOverrides("groupHeading", state));
    },
    indicatorsContainer: function indicatorsContainer(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("indicatorsContainer", state), themeOverrides("indicatorsContainer", state))), propsOverrides("indicatorsContainer", state));
    },
    input: function input(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("input", state), themeOverrides("input", state))), propsOverrides("input", state));
    },
    loadingIndicator: function loadingIndicator(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("loadingIndicator", state), themeOverrides("loadingIndicator", state))), propsOverrides("loadingIndicator", state));
    },
    loadingMessage: function loadingMessage(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("loadingMessage", state), themeOverrides("loadingMessage", state))), propsOverrides("loadingMessage", state));
    },
    menuList: function menuList(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("menuList", state), themeOverrides("menuList", state))), propsOverrides("menuList", state));
    },
    menuPortal: function menuPortal(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("menuPortal", state), themeOverrides("menuPortal", state))), propsOverrides("menuPortal", state)), {}, {
        zIndex: _constants.Z_INDEX.Select
      });
    },
    noOptionsMessage: function noOptionsMessage(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("noOptionsMessage", state), themeOverrides("noOptionsMessage", state))), propsOverrides("noOptionsMessage", state));
    },
    valueContainer: function valueContainer(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), (0, _mergeProps.default)(mainOverrides("valueContainer", state), themeOverrides("valueContainer", state))), propsOverrides("valueContainer", state));
    }
  };
};
var _default = exports.default = createSelectOverrides;